import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { VendorListRoutingModule } from './vendor-list-routing.module';
import { VendorListPage } from './vendor-list.page';
import { SharedModule } from '../shared/shared.module';
import { VendorDetailsComponent } from './vendor-details/vendor-details.component';
import { VendorUpdateComponent } from './vendor-update/vendor-update.component';



@NgModule({
  declarations: [
    VendorListPage,
    VendorUpdateComponent,
    VendorDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VendorListRoutingModule,
    IonicModule,
    SharedModule
  ]
})
export class VendorListModule { }
